/**
 * @generated SignedSource<<e15631cc767168754fc08fe038b176f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GraphQLJobRunStatus = "COMPLETED" | "ERRORED" | "IN_PROGRESS" | "PENDING" | "STOPPED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AlertResponderJobRun_jobRun$data = {
  readonly llmConversation: {
    readonly " $fragmentSpreads": FragmentRefs<"AlertResponderConversationWithRefetch_llmConversation">;
  } | null | undefined;
  readonly outputJson: any | null | undefined;
  readonly status: GraphQLJobRunStatus;
  readonly " $fragmentType": "AlertResponderJobRun_jobRun";
};
export type AlertResponderJobRun_jobRun$key = {
  readonly " $data"?: AlertResponderJobRun_jobRun$data;
  readonly " $fragmentSpreads": FragmentRefs<"AlertResponderJobRun_jobRun">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AlertResponderJobRun_jobRun",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "outputJson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLLlmConversation",
      "kind": "LinkedField",
      "name": "llmConversation",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AlertResponderConversationWithRefetch_llmConversation"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLJobRun",
  "abstractKey": null
};

(node as any).hash = "66b10e03733d536f6b7338c87f5f0472";

export default node;
